import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { formatINR } from "@/api";

const TAG_STYLE = {
  NEW: "bg-[#0A0A0A] text-white",
  SALE: "bg-[#E31837] text-white",
  BESTSELLER: "bg-white text-[#0A0A0A] border border-[#0A0A0A]",
};

export default function ProductCard({ product }) {
  const to = product.group === "equipment" ? `/equipment/product/${product.slug}` : `/product/${product.slug}`;
  return (
    <Link
      to={to}
      className="group block border border-border bg-white hover:border-[#0A0A0A] btn-transition"
      data-testid={`product-card-${product.slug}`}
    >
      <div className="relative overflow-hidden bg-[#0A0A0A] aspect-square">
        {product.tag && (
          <span className={`absolute top-3 left-3 z-10 label-caps px-2.5 py-1 ${TAG_STYLE[product.tag] || TAG_STYLE.NEW}`}>
            {product.tag}
          </span>
        )}
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full card-hover-img knockout-white group-hover:scale-105"
          style={{ objectFit: product.image_fit || "cover", objectPosition: product.image_position || "center" }}
        />
        <div className="absolute inset-x-0 bottom-0 bg-[#0A0A0A] text-white py-3 text-center label-caps translate-y-full group-hover:translate-y-0 btn-transition flex items-center justify-center gap-1">
          Shop Now <ArrowUpRight className="h-4 w-4" />
        </div>
      </div>
      <div className="p-4">
        <p className="label-caps text-muted-foreground mb-1">{product.category}</p>
        <h3 className="font-head text-lg font-bold uppercase tracking-tight leading-tight">{product.name}</h3>
        <div className="mt-2 flex items-center gap-2">
          <span className="font-bold">{formatINR(product.price)}</span>
          {product.old_price && (
            <span className="text-sm text-muted-foreground line-through">{formatINR(product.old_price)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
